export default "__VITE_ASSET__sIrVsTaw__"